// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"c5a799ca","617":"fd2020e3"}[chunkId] + ".chunk.js";
};